import React from 'react'

import {withStyles} from 'material-ui'

import TitledPage from './TitledPage'
import MainNav from './MainNav'
import Features1 from './Features1'
import Features2 from './Features2'
import Plans from './Plans'
import Bios from './Bios'
import MainHeader from './MainHeader'


const styles = theme => ({

    container: {
        position: 'relative',
    },
})

export class Home extends React.Component {

    render() {
        const {classes} = this.props
        return (
            <TitledPage title="Carefol.io" nologo>
                <div className={classes.container}>
                    <MainHeader/>
                    <Features1/>
                    <Plans/>
                    <Bios/>
                </div>
            </TitledPage>
        )
    }
}

export default withStyles(styles)(Home)



// WEBPACK FOOTER //
// ./src/components/Home.jsx